import React from 'react';
import Modal from '@/ctComponents/Modal';
import { TableV2 } from '@/components/TableV2';
import { Icons } from '@/assets';
import { Icon } from '@/components/Icon';

const TABLE_HEADERS = [
  'Size',
  'SSL',
  'Location',
  'Saved Date',
  'Removed Date',
  'Status',
];

export const SavedSearchesHistoryModal = ({ data, show, setShow }) => {
  const formatDate = (date) => {
    if (!date) return '';

    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = String(d.getFullYear()).slice(-2);
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${month}-${day}-${year} ${hours}:${minutes}`;
  };

  const prepareTableData = () => {
    return data.map((item, index) => ({
      id: item.id,
      cellData: [
        item.cabin.specifications.size_type || '-',
        item.cabin.company.name || '-',
        item.city || '-',
        formatDate(item.date),
        formatDate(item.date),
        <span
          className={` text-11 gap-1 h-5 flex items-center m-auto w-fit justify-center px-2 rounded-full bg-error-light text-error `}>
          <Icon
            src={item.status === 'expired' ? Icons.clocktime : Icons.trashIcon}
            width={16}
            height={16}
          />
          {item.status === 'expired' ? 'Expired' : 'Deleted'}
        </span>,
      ],
    }));
  };

  return (
    <Modal
      minWidth="unset"
      show={show}
      notClose={true}
      children={
        <div className="overflow-x-auto max-w-sm sm:max-w-2xl">
          <p className="text-sm text-secondary-text my-6">
            View your referral history, including who you invited, when, and
            their current status.
          </p>

          <div className="w-full">
            <TableV2
              minWidth={600}
              headers={TABLE_HEADERS}
              data={prepareTableData()}
              emptyMessage="No Saved searches history"
            />
          </div>
        </div>
      }
      icon={'timeFile'}
      title="Saved Searches History"
      setShow={setShow}
    />
  );
};
